export default "__VITE_ASSET__BHAUyxG___"